/** 활동 팝업 보내는 사람 아이콘 */
export const SEND_WALLET_IMG_PATH = 'img/wallet-img.png';

/** 활동 팝업 받는 사람 아이콘 */
export const RECEIVE_WALLET_IMG_PATH = 'img/wallet-img2.png';

/** 뒤로가기 아이콘 */
export const BACK_ICON_PATH = 'img/back-icon.png';

/** alert 아이콘 */
export const ALERT_ICON_PATH = 'img/alert-icon.png';

/** T Logo 아이콘 */
export const T_LOGO_ICON_PATH = 'img/Tlogo.png';

/** asset reset 아이콘 */
export const ASSET_RESET_ICON_PATH = 'img/reset-icon.png';

/** 트론 SYMBOL 아이콘 */
export const TRX_SYMBOL_ICON_PATH = 'img/symbol-trx.png';

/** 더블에서 SYMBOL 아이콘 */
export const TOKEN_SYMBOL_ICON_PATH = 'img/symbol-ss.png';
